import showdown from "showdown";
import targetblank from "showdown-target-blank";

var converter = new showdown.Converter({ extensions: [targetblank] });
export const HandleMarkdown = (survey, options) => {
    //convert the markdown text to html
    var str = converter.makeHtml(options.text);
    //remove root paragraphs <p></p>
    str = str.substring(3);
    str = str.substring(0, str.length - 4);

    //set html
    options.html = str;

    if (str.indexOf("\n") > -1) {
        var res = "";
        var strs = str.split("\n");
        for (var i = 0; i < strs.length; i++) {
            if (i < strs.length - 1) {
                res += "<span>";
            }
            res += strs[i];
            if (i < strs.length - 1) {
                res += "<br/></span>";
            }
        }
        options.html = res;
    }
}